var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComponent5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "40.000000pt",
    height: "41.000000pt",
    viewBox: "0 0 40.000000 41.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,41.000000) scale(0.100000,-0.100000)",
    fill: "#473D8D",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 403 c-13 -12 -8 -368 5 -381 15 -15 388 -17 388 -2 0 6 -72 11 -182 12 l-183 3 -3 180 c-2 166 -8 206 -25 188z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262 338 c3 -7 24 -15 47 -18 l42 -5 -60 -60 -61 -59 -30 29 -31 29 -56 -56 c-34 -35 -53 -60 -48 -68 5 -8 23 3 56 36 l49 48 23 -22 c13 -12 27 -22 32 -22 5 0 40 30 77 67 l68 67 0 -47 c0 -36 4 -47 15 -47 13 0 15 12 13 68 l-3 67 -68 3 c-53 2 -68 0 -65 -10z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent5);
export default __webpack_public_path__ + "static/media/component-5.0e86f61a3305f7b35ffcfc704c80f77b.svg";
export { ForwardRef as ReactComponent };